import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Box } from '@chakra-ui/react';

const MeasurementSummaryImage = () => (
  <Box marginBottom={['0', '0', '0', '30%']}>
    <StaticImage
      src="../../images/measurement-summary-image.webp"
      alt="View of the Measurement summary"
    />
  </Box>
);
export default MeasurementSummaryImage;
